import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { IoKeyOutline, IoSaveOutline } from "react-icons/io5";
import api from "@/api";
import { useI18n, STORE_LABELS } from "@/i18n";
import { AppHeader } from "@/components/AppHeader";
import { BottomNav } from "@/components/BottomNav";

const FIELDS = [
  { key: "titolare", label: "Titolare (Marco)" },
  { key: "jannelli", label: "Direttore Jannelli" },
  { key: "mazzini", label: "Direttore Mazzini" },
  { key: "materdomini", label: "Direttore Materdomini" },
  { key: "parafarmacia", label: "Direttore Parafarmacia" },
];

export default function CredentialsPage() {
  const { t } = useI18n();
  const [values, setValues] = useState({});
  const [initial, setInitial] = useState({});
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/passwords");
      setValues(data);
      setInitial(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore caricamento");
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const changed = FIELDS.some((f) => values[f.key] !== initial[f.key]);

  const save = async () => {
    const changes = {};
    for (const f of FIELDS) {
      if (values[f.key] && values[f.key] !== initial[f.key]) changes[f.key] = values[f.key];
    }
    if (Object.keys(changes).length === 0) { toast.info("Nessuna modifica"); return; }
    setSaving(true);
    try {
      await api.put("/admin/passwords", changes);
      toast.success(`Aggiornate ${Object.keys(changes).length} password`);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore salvataggio");
    } finally { setSaving(false); }
  };

  return (
    <div className="mobile-frame with-bottom-bar" data-testid="credentials-page">
      <AppHeader title="Credenziali" showBack backTo="/" />
      <div className="tf-content">
        <div className="tf-financial-card" style={{ background: "linear-gradient(135deg, #111214 0%, #1E1F23 100%)" }}>
          <div className="tf-row" style={{ gap: 12, alignItems: "center" }}>
            <IoKeyOutline size={26} />
            <div>
              <div style={{ fontWeight: 700 }}>Gestione password</div>
              <div className="tf-small" style={{ opacity: 0.75 }}>Solo il titolare può modificare</div>
            </div>
          </div>
        </div>

        {FIELDS.map((f) => (
          <div key={f.key} className="tf-field">
            <label className="tf-label">{f.label}</label>
            <input
              data-testid={`pwd-${f.key}`}
              className="tf-input"
              type="text"
              value={values[f.key] || ""}
              onChange={(e) => setValues({ ...values, [f.key]: e.target.value })}
              placeholder="—"
              autoComplete="off"
            />
          </div>
        ))}

        <button
          data-testid="pwd-save"
          className="tf-btn-primary"
          disabled={!changed || saving}
          onClick={save}
        >
          <IoSaveOutline size={18} />
          {saving ? "Salvataggio…" : "Salva modifiche"}
        </button>
      </div>
      <BottomNav />
    </div>
  );
}
